import React, { useState, useRef, useEffect } from 'react';
import Error from '../../Common/Error'
import Gender from '../../Common/Gender'


/* Focus on the input field on Tab change */
export const useMountEffect = (fun) => useEffect(fun, []);
const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => {htmlElRef.current &&  htmlElRef.current.focus()}

    return [ htmlElRef, setFocus ] 
}

const SearchByName = (props) => {

    const [buttonEditable, setButtonEditable] = useState(true)
    const [searchTerm, setSearchTerm] = useState('')
    const [searchType] = useState(props.searchtype)
    const [genderType, setGenderType] = useState('')
    const [genderData] = useState(props.gender)
    const [errorDetails, setErrorDetails] = useState({
        errorMsg: props.errorDetails.type === 'searchbyname' ? props.errorDetails.errorData : null,
        errorStatus: props.errorDetails.type === 'searchbyname' ? props.errorDetails.errorBlk : false
    })

    const [input1Ref, setInput1Focus] = useFocus()

    const handleNameChange = (event) => {
        setErrorDetails({
            errorMsg: null,
            errorStatus: false
        })

        /* Add Validation to the input field not to allow any special characters other than 'space only' */
        let target = event.target.value.replace(/[^A-Za-z]/ig, '')
        if(event.target.value.length === 0){
            setButtonEditable(true)
            setSearchTerm(target)
        } else if(event.target.value.length === 1){
            if(target === '' || target === null){                
                setButtonEditable(true)
                setSearchTerm(target)
            } else {
                setButtonEditable(false)
                setSearchTerm(target)
            }            
        } else {     
            target = event.target.value.replace(/[^A-Za-z ]/ig, '')
            setButtonEditable(false)
            setSearchTerm(target)  
        }      
    }
    const eventGenderHandler = (data) => { setGenderType(data.gender) }
    const eventDataHandler = (data) => {         
        data(searchTerm,searchType,genderType,buttonEditable) 
    }

    useEffect(() => {
        setErrorDetails({
            errorMsg: null,
            errorStatus: false
        })
        setSearchTerm(searchTerm => {
            return props.clearTermActive ? searchTerm : ''
        })
        !buttonEditable &&
        setErrorDetails({
            errorMsg: props.errorDetails.type === 'searchbyname' ? props.errorDetails.errorData : null,
            errorStatus: props.errorDetails.type === 'searchbyname' ? props.errorDetails.errorBlk : false
        })
    }, [props.clearTermActive, props.errorDetails.errorBlk])

    useMountEffect( setInput1Focus )

    return(        
        <React.Fragment>
            <div className="blk blk-name">
                {
                   props.clearTermActive && errorDetails.errorStatus && <Error errormsg={errorDetails.errorMsg} /> 
                } 
                <input type="text" placeholder={props.searchnamelabel} value={searchTerm} onChange={handleNameChange.bind(this)} ref={input1Ref} />
                <div className="genderWrapper">
                    <label>{props.compgenderlabel}</label>
                    <div className="genderlist">
                        {
                            genderData.map(item => <Gender key={item.id} fields={item.fields} onChange={(e) => eventGenderHandler(e)} selected={genderType}  />)
                        }
                    </div>
                </div>
                <div className='blk blk-btn'>
                    <input 
                        type="submit" 
                        id="name-search-button" 
                        className="btn btn-p"
                        value={props.searchlabel} 
                        disabled={buttonEditable}                         
                        onClick={() => eventDataHandler(props.onFetchData)} />
                </div>        
            </div>
        </React.Fragment> 
    )
}

export default SearchByName;